<form class="p-grid body" [formGroup]="formGroup" (ngSubmit)="submitChange()">

    <div class="p-col-12 p-lg-10 p-xl-10 p-grid" >
        <div class="p-col-12 p-lg-4 p-xl-4">
            <div class="p-grid">
                <div class="p-col-4 ui-label">
                    Ancien mot de passe
                </div>
                <div class="p-col-8">
                    <input pInputText  type="password" class="ui-input" formControlName="actualPassword">
                </div>
                <div class="p-col-12" *ngIf="f().actualPassword.errors">
                    <div class="ui-errors" *ngIf="f().actualPassword.errors.required"> *Ce champ est requis</div>
                </div>
            </div>
        </div>
    
        <div class="p-col-12 p-lg-4 p-xl-4">
            <div class="p-grid">
                <div class="p-col-4 ui-label">
                    Nouveau mot de passe
                </div>
                <div class="p-col-8">
                    <input pInputText type="password" class="ui-input" formControlName="newPassword">
                </div>
                <div class="p-col-12" *ngIf="f().newPassword.errors">
                    <div class="ui-errors" *ngIf="f().newPassword.errors.required"> *Ce champ est requis</div>
                    <div class="ui-errors" *ngIf="f().newPassword.errors.hasNumber"> *Au moins un chiffre</div>
                    <div class="ui-errors" *ngIf="f().newPassword.errors.hasCapitalCase"> *Au moins une lettre capitale</div>
                    <div class="ui-errors" *ngIf="f().newPassword.errors.hasSmallCase"> *Au moins une lettre en minuscule</div>
                    <div class="ui-errors" *ngIf="f().newPassword.errors.hasSpecialCharacters"> *Au moins un caractère spécial</div>
                </div>
            </div>
        </div>
    
        <div class="p-col-12 p-lg-4 p-xl-4">
            <div class="p-grid">
                <div class="p-col-4 ui-label">
                    Confirmer le mot de passe
                </div>
                <div class="p-col-8">
                    <input pInputText type="password" class="ui-input" formControlName="confirmPassword">
                </div>
                <div class="p-col-12" *ngIf="f().confirmPassword.errors">
                    <div class="ui-errors" *ngIf="f().confirmPassword.errors.required"> *Ce champ est requis</div>
                    <div class="ui-errors" *ngIf="f().confirmPassword.errors.mustMatch"> *Les deux mot de passe ne correspondent pas</div>
                </div>
            </div>
        </div>
    </div>

    <div class="p-col-12 p-lg-2 p-xl-2">
        <button pButton label="Changer" class="ui-btn" [disabled]="disableButton()"></button>
    </div>
    
</form>
